import React, { useState } from "react";
import toast from "react-hot-toast";
import { useFirestoreAdmin } from "../context/FirestoreAdminProvider";
import BulkOperationsPanel from "../components/BulkOperationsPanel";

export default function FieldManagerPage() {
  const { collectionName, selectCollection, allCollections } = useFirestoreAdmin();
  const [oldField, setOldField] = useState("");
  const [newField, setNewField] = useState("");

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-2xl font-bold">Field Manager</h1>
        <p className="text-sm text-slate-600">Rename, delete, merge, and convert fields via bulk operations with dry run.</p>
      </header>
      <div className="fa-card p-4">
        <select className="mb-3 rounded-lg border border-slate-300 px-2 py-1.5 text-sm" value={collectionName} onChange={(e) => selectCollection(e.target.value)}>
          {allCollections.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
        <p className="mb-2 text-sm text-slate-600">
          Use bulk tools below on selected documents in Collection Explorer, or configure rename here then run bulk update from Explorer.
        </p>
        <div className="flex flex-wrap gap-2">
          <input className="rounded-lg border px-2 py-1.5 text-sm" placeholder="Old field" value={oldField} onChange={(e) => setOldField(e.target.value)} />
          <input className="rounded-lg border px-2 py-1.5 text-sm" placeholder="New field" value={newField} onChange={(e) => setNewField(e.target.value)} />
          <button
            type="button"
            className="fa-btn"
            onClick={() => {
              if (!oldField || !newField) return toast.error("Enter both fields");
              toast.success(`Use Bulk → Rename field: ${oldField} → ${newField} in Explorer`);
            }}
          >
            Prepare rename
          </button>
        </div>
      </div>
      <BulkOperationsPanel />
    </div>
  );
}
